import clsx from 'clsx'
import React from 'react'

import { DrawerPageAsync } from '@Components/Drawer/Page'
import { Wordbook } from '@Components/Wordbook'
import { PageType } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'
import { Checkbox } from '@Shared/Components/Inputs/Checkbox/Checkbox'

import styles from './ClubTerms.module.scss'

// Cannot be inlined: Wordbook (Trans) clones this element with the link text as
// children, and DrawerPageAsync would route those children into the drawer body —
// this reroutes them into the trigger button instead.
const TermsDrawerLink = ({
  children,
  pageID,
  pageType,
}: {
  children?: React.ReactNode
  pageID: string
  pageType: PageType
}) => (
  <DrawerPageAsync
    pageID={pageID}
    pageType={pageType}
    sourceID="club_terms"
    triggerRender={props => (
      <button {...props} className={styles.termsModalButtons} type="button">
        {children}
      </button>
    )}
  />
)

export const ClubTerms = ({
  accepted,
  children,
  className,
  onAccept,
}: {
  accepted: boolean
  children?: React.ReactNode
  className?: string
  onAccept: (accepted: boolean) => void
}) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(styles.clubTerms, className)}>
      <Checkbox
        className={styles.termsCheckbox}
        label={t('common:TRENDHIMCLUB_ACCEPT_TERMS_OF_SERVICE')}
        setInputValue={onAccept}
        value={accepted}
      />
      {children}
      <Wordbook
        components={{
          LinkPolicy: <TermsDrawerLink pageID="309" pageType={PageType.Terms} />,
          LinkService: <TermsDrawerLink pageID="2323" pageType={PageType.Landingpage} />,
        }}
        wordbook={{ defaults: t('common:TRENDHIMCLUB_COF_TERMS_ACCEPT') }}
      />
    </div>
  )
}
